import KanBoIcon from './KanBoIcon'
export default KanBoIcon
